
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"11","viewBox":"0 0 11 11","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.96 4.748c0-.295.147-.554.37-.713a1.446 1.446 0 00-.662-.166c-.808 0-1.465.657-1.465 1.465s.657 1.465 1.465 1.465c.723 0 1.322-.528 1.44-1.218a.874.874 0 01-1.147-.833z"}}),_c('path',{attrs:{"d":"M10.59 5.139c-.09-.1-2.237-2.442-4.926-2.442S.828 5.04.74 5.14c-.1.11-.1.28 0 .39.089.1 2.236 2.442 4.925 2.442 2.69 0 4.836-2.342 4.925-2.442.1-.11.1-.28 0-.39zM5.663 7.385c-1.13 0-2.05-.92-2.05-2.051 0-1.13.92-2.05 2.05-2.05s2.05.92 2.05 2.05-.92 2.05-2.05 2.05z"}})])
          )
        }
      }
    